import { initializeApp } from "firebase/app";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

const firebaseConfig = {
    apiKey: "AIzaSyAn6wO39uXIlb_EZDTMIvCyUh1i-o4HtNE",
    authDomain: "quad-cores.firebaseapp.com",
    projectId: "quad-cores",
    storageBucket: "quad-cores.firebasestorage.app",
    messagingSenderId: "764351776211",
    appId: "1:764351776211:web:56d3475e62b77183001b26",
    measurementId: "G-SHJKNNJY5R"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

let appCheck;
if (typeof window !== 'undefined') {
    // Enable debug token for local development
    if (import.meta.env.DEV) {
        self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
    }

    appCheck = initializeAppCheck(app, {
        provider: new ReCaptchaV3Provider('6Le6w2ssAAAAAL_I6u9scKX4IPjnrUHkGZjWUPXw'),
        isTokenAutoRefreshEnabled: true
    });
}

export { app, appCheck };
